import { useMemo } from 'react';
import { useParticipantAttributes, useParticipants } from '@livekit/components-react';
import { type Participant, RoomEvent } from 'livekit-client';

export const LOCAL_RECORDING_ATTRIBUTE = 'local_recording_started_at';

export function localRecordingStartedAt(attributes: Readonly<Record<string, string>> | undefined): number {
    const startedAt = Number(attributes?.[LOCAL_RECORDING_ATTRIBUTE]);
    return Number.isFinite(startedAt) ? startedAt : 0;
}

export function useLocalRecorders(): Participant[] {
    const participants = useParticipants({ updateOnlyOn: [RoomEvent.ParticipantAttributesChanged] });
    return useMemo(
        () => participants.filter((participant) => localRecordingStartedAt(participant.attributes) > 0),
        [participants]
    );
}

export function useIsRecordingLocally(participant: Participant): boolean {
    const { attributes } = useParticipantAttributes({ participant });
    return localRecordingStartedAt(attributes) > 0;
}
